export const CIRCULAR_PROGRESS_TYPES = {
  danger: 'danger',
  white: 'white',
};

export const CIRCULAR_PROGRESS_SIZE_NAMES = {
  extraSmall: 'extraSmall',
  small: 'small',
  medium: 'medium',
};

export const CIRCULAR_PROGRESS_COLOR = {
  primary: '#07364b',
  danger: '#e71b4c',
  white: '#ffffff',
};

export const CIRCULAR_PROGRESS_SIZE = {
  extraSmall: 15,
  small: 30,
  medium: 60,
};
